import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from 'app/components/ui/command'
import type { LocationJson } from 'app/types/entities'
import { PickerButton } from './PickerButton'

/** The locations this user may choose from, searchable, with the chosen one as the trigger. */
export function LocationPicker({
  locations,
  value,
  onChange,
}: {
  locations: LocationJson[]
  value: string
  onChange: (id: string) => void
}) {
  const selected = locations.find((l) => l.id === value)
  return (
    <PickerButton
      label={selected?.name ?? `Pick a location`}
      muted={!selected}
      align="start"
      contentClassName="w-[280px] p-0"
    >
      {(close) => (
        <Command className="bg-surface">
          <CommandInput placeholder="Search locations…" />
          <CommandList>
            <CommandEmpty>No locations</CommandEmpty>
            <CommandGroup>
              {locations.map((location) => (
                <CommandItem
                  key={location.id}
                  value={location.name ?? location.id}
                  onSelect={() => {
                    onChange(location.id!)
                    close()
                  }}
                >
                  <span className="truncate">{location.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      )}
    </PickerButton>
  )
}
